import { render, staticRenderFns } from "./HistoricalEventDetails.vue?vue&type=template&id=7483ad40&scoped=true&"
import script from "./HistoricalEventDetails.vue?vue&type=script&lang=js&"
export * from "./HistoricalEventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7483ad40",
  null
  
)

export default component.exports